import config from "config";
import { defaultHeaders, handleResponse } from "./common";
const {
  constants: {
    API: { BASE_URL },
  },
} = config;

export const apiService_be = {
  post: async (endpoint, body) => {
    try {
      const response = await fetch(`${BASE_URL}${endpoint}`, {
        method: "POST",
        headers: { ...defaultHeaders },
        body: JSON.stringify(body),
      });

      return handleResponse(response);
    } catch (error) {
      throw error;
    }
  },
};


